import { Card, CardContent } from "@/components/ui/card"
import { useTranslation } from "react-i18next"
import { Star } from "@solar-icons/react"

const TESTIMONIAL_ITEMS = [
  { key: "sarah" as const, author: "Sarah Johnson" },
  { key: "michael" as const, author: "Dr. Michael Chen" },
  { key: "emily" as const, author: "Emily Rodriguez" },
  { key: "james" as const, author: "James Wilson" },
  { key: "lisa" as const, author: "Lisa Park" },
  { key: "david" as const, author: "David Thompson" },
]

export function TestimonialsSection() {
  const { t } = useTranslation("marketing")

  return (
    <section className="py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            {t("testimonials.title")}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-6xl gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIAL_ITEMS.map((testimonial) => (
            <Card key={testimonial.key} className="overflow-hidden">
              <CardContent className="p-6">
                <div className="flex gap-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className="h-4 w-4 fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>
                <blockquote className="mt-4 text-muted-foreground">
                  "{t(`testimonials.items.${testimonial.key}.content`)}"
                </blockquote>
                <div className="mt-6 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 text-white font-semibold">
                    {testimonial.author.charAt(0)}
                  </div>
                  <div>
                    <div className="font-medium">{testimonial.author}</div>
                    <div className="text-sm text-muted-foreground">
                      {t(`testimonials.items.${testimonial.key}.role`)}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
